export default "__VITE_ASSET__Z$isBg3A__"